var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.image)?_c('div',{staticClass:"channel-ads inset",class:[_vm.position]},[_c('div',{staticClass:"inline-block"},[_c('img',{attrs:{"src":_vm.image}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }